<template>
    <v-dialog v-model="showDialog" max-width="600px" persistent>
        <v-sheet class="dialog" rounded>
            <div class="dialog-header">
                {{ $t("login.reset_password") }}
            </div>
            <div class="dialog-content">
                <v-form v-model="valid">
                    <v-text-field
                        v-model="oldPassword"
                        :label="$t('login.old_password')"
                        :rules="passwordRules"
                        dense
                        outlined
                        type="password"
                    ></v-text-field>

                    <v-text-field
                        v-model="password"
                        :label="$t('login.password_new')"
                        :rules="passwordRules"
                        dense
                        outlined
                        type="password"
                    ></v-text-field>

                    <v-text-field
                        v-model="passwordConfirm"
                        :label="$t('login.password_confirm')"
                        :rules="passwordConfirmRules"
                        dense
                        outlined
                        type="password"
                    ></v-text-field>

                </v-form>
            </div>
            <div class="dialog-footer d-flex">
                <v-btn elevation="0"
                       @click="showDialog = false">
                    {{ $t("global.cancel") }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn :disabled="!valid" :loading="loading"
                       color="primary" elevation="0"
                       @click="handleClick">
                    {{ $t("global.validate") }}
                </v-btn>
            </div>
        </v-sheet>
    </v-dialog>
</template>

<script>
export default {
    name: "ResetPassword",
    props: {
        visible: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data() {
        return {
            valid: false,
            password: null,
            loginRules: [(v) => !!v || this.$t("login.required_login")],
            passwordRules: [(v) => !!v || this.$t("login.required_login")],
            passwordConfirmRules: [(v) => !!v && v === this.password || this.$t("login.required_login")],
            passwordConfirm: null,
            oldPassword: null,
            loading: false,
        }
    },
    computed: {
        showDialog: {
            get() {
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        async handleClick() {
            try {
                this.loading = true
                await this.$api.users.updatePassword(this.$auth.user().id, {
                    old_password: this.oldPassword,
                    password: this.password
                })
                this.$emit('close')
            } catch (e) {
            } finally {
                this.loading = false
            }
        }
    }
}
</script>

<style scoped>

</style>
